import { Const } from "../common/const/const";

export const extractDigits = (value: string, isMinus?: boolean): number => {
  if (isMinus) {
    const raw = value;
    // - 허용
    const parsed = raw.replace(/,/g, "").replace(/(?!^-)[^0-9]/g, "");

    return parsed === "-" ? -0 : Number(parsed);
  } else return +value.replace(/\D/g, "");
};

export const exchangePoint = (value?: number) => {
  if (!value) return "0";
  return Number(value / Const.POINT_RATE)?.toLocaleString();
};

export const exchangePointToWon = (value: number) => {
  return Number(value * Const.POINT_RATE);
};

export const exchangeSeed = (value?: number) => {
  if (!value) return "0";
  return Number(value / Const.SEED_RATE)?.toLocaleString();
};
